// extracted by mini-css-extract-plugin
module.exports = {"PartsSlider":"utNxj6UYd96mQKLYxoyLnw==","PartPagination":"Ovnb-rLeM3TyGhP7BZA9rg==","SliderNav":"d6JP2G-Pb8THVmEF83+UuA=="};